import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Projects } from "@/components/Projects";
import { Milestones } from "@/components/Milestones";
import { Skills } from "@/components/Skills";
import { BeyondCode } from "@/components/BeyondCode";
import { Approach } from "@/components/Approach";
import { Journey } from "@/components/Journey";
import { Contact } from "@/components/Contact";
import CaseStudyBioPay from "@/pages/CaseStudyBioPay";
import CaseStudyAWG from "@/pages/CaseStudyAWG";

const Home = () => (
  <main>
    <Hero />
    <About />
    <Projects />
    <Milestones />
    <Skills />
    <BeyondCode />
    <Approach />
    <Journey />
    <Contact />
  </main>
);

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#080808] text-[#F9F9F9] min-h-screen" data-testid="portfolio-app">
      <BrowserRouter>
        <ScrollReset />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/case-study/biopay" element={<CaseStudyBioPay />} />
          <Route path="/case-study/atmospheric-water-generator" element={<CaseStudyAWG />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
